import { get } from 'lodash';

export const getDialog = (state, index = 0) =>
  get(state, `NotificationDialogState.dialogQueue.${index}`, {});

export const getDialogMessage = (state, index = 0) =>
  get(getDialog(state, index), 'message', '');

export const getDialogTitle = (state, index = 0) =>
  get(getDialog(state, index), 'title', '');

export const getShowDialog = (state, index = 0) =>
  get(getDialog(state, index), 'show', false);

export const getShowCancel = (state, index = 0) =>
  get(getDialog(state, index), 'showCancel', false);

export const getActionsToDispatchOnOk = (state, index = 0) =>
  get(getDialog(state, index), 'actionsToDispatchOnOk', []);

export const getActionsToDispatchOnCancel = (state, index = 0) =>
  get(getDialog(state, index), 'actionsToDispatchOnCancel', []);

export const getFunctionsToRunOnOk = (state, index = 0) =>
  get(getDialog(state, index), 'functionsToRunOnOk', []);

export const getFunctionsToRunOnCancel = (state, index = 0) =>
  get(getDialog(state, index), 'functionsToRunOnCancel', []);

export const getOkButtonText = (state, index = 0) =>
  get(getDialog(state, index), 'okButtonText');

export const getYesNoDialogProps = state =>
  get(state, 'NotificationDialogState.yesNoDialogProps', { showDialog: false });



// WEBPACK FOOTER //
// ./src/components/dialogs/state/selectors.js